import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { loadGatewaysWithSourcesListsData } from "@src/cloud-connect/use-cases/load-gateway-lists-data";
import { gatewaysListsResultsAreReadyButEmpty } from "../gateways-component-use-case";
import { updateServerListsResultsReady } from "@src/reducers/your-reducer";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";

export const useGatewaysData = (isActive: boolean) => {
  const dispatch = useDispatch();

  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );

  const gatewaysListsResultsReady = useSelector(
    (state: RootState) => state.yourSlice.gatewaysWithSourcesResultsReady,
  );

  const connectedGatewaysListData = useSelector(
    (state: RootState) => state.yourSlice.connectedGatewaysListData,
  );

  const sourcesListResultsReady = useSelector(
    (state: RootState) => state.yourSlice.serverListsResultsReady,
  );

  const hasGatewayRole =
    authContext &&
    (authContext.permissions.includes("view-gateways") ||
      authContext.permissions.includes("manage-gateways"));

  useEffect(() => {
    // if the active view is not gatewaysList, we don't need to run this useEffect
    if (!isActive || !hasGatewayRole) return;

    if (!gatewaysListsResultsReady && authContext) {
      loadGatewaysWithSourcesListsData();
    }

    // resetting the sources lists results ready state while the gateways render
    // to ensure that the next time the sources list is accessed,
    // it will re-fetch the data
    if (sourcesListResultsReady !== false) {
      dispatch(updateServerListsResultsReady(false));
    }
  }, [isActive, hasGatewayRole, gatewaysListsResultsReady, authContext]);

  const getViewState = () => {
    if (!gatewaysListsResultsReady) {
      return "SpinningForData";
    }

    if (!hasGatewayRole) {
      navigateTo(Route.MACHINES);
    }

    if (
      gatewaysListsResultsAreReadyButEmpty(
        gatewaysListsResultsReady,
        connectedGatewaysListData,
      )
    ) {
      return "NoGatewaysDetectedView";
    }

    return "GatewaysListsView";
  };

  return {
    viewState: getViewState(),
    hasGatewayRole,
    gatewaysListsResultsReady,
    connectedGatewaysListData,
  };
};
